import { getDoc, updateDoc } from "firebase/firestore";
import { getUserDocRef } from ".";
import { User } from "@version2/domain-package";

const getUserDoc = async () => {
  const userDocRef = await getUserDocRef();
  const userDoc = await getDoc(userDocRef);
  return User.fromFirestore(userDoc);
};

const updateUserDoc = async (username?: string) => {
  const userDocRef = await getUserDocRef();
  const payload = {
    ...(username && { username }),
  };
  await updateDoc(userDocRef, payload);
};

export { getUserDoc, updateUserDoc };
